<template>
  <div class="">
    <van-nav-bar
        title="保险（B款）条款"
        left-text="返回"
        right-text=""
        left-arrow
        :fixed="true"
        @click-left="onClickLeft"
    />
    <div class="form-content">

      <div class="">
        <div class="rule-detail">
          <p class="text bold text-center">中国平安财产保险股份有限公司</p>
          <p class="text bold text-center">平安产险团体意外伤害保险（B 款）条款</p>
          <p class="text bold text-center">注册号：C00001732312024071521373</p>
          <p class="text bold text-center">总则</p>

          <p class="text"><span class="space"></span><span class="bold">第一条</span> 本保险合同（以下简称“本合同 ”）
            由本保险条款、保险单或其他保险凭证、 投保单、 被保险人名册等与本合同有关的投保文件、合法有效的声明、批注、批单、其他书面协议等构成。凡涉及本合同的约定，均应采用书面形式。
          </p>
          <p class="text"><span class="space"></span>本合同自保险人同意承保、收取保险费并签发保险单开始生效，
            具体生效日以保险单所载的日期为准。</p>
          <p class="text"><span class="space"></span><span class="bold">第二条</span>
            团体可作为投保人，为其符合保险人承保条件的成员向保险人投保本保险。参保成员的父母、配偶与子女也可参加本保险，
            与参保成员统称为被保险人。另有约定的按约定内容执行。被保险人必须符合法律及监管规定的要求。</p>
          <p class="text"><span class="space"></span><span class="bold">第三条</span> 投保人或者被保险人可以指定一人或数人为保险金受益人。除另有约定外，
            本合同的意外伤残保险金、工作期间意外伤残保险金、非工作期间意外伤残保险金、工作期间火灾意外伤残保险金、法定节假日意外伤残保险金、烧伤意外伤残保险金、燃气意外伤残保险金、食物中毒意外全残保险金、特定场所意外伤残保险金、特定场景意外伤残保险金、见义勇为意外伤残保险金受益人为被保险人本人。
          </p>
          <p class="text"><span class="space"></span>受益人为数人时，投保人或者被保险人可以确定受益顺序和受益份额的，按确定的受益顺序和受益份额享有受益权；未确定受益份额的，各受益人按照相等份额享有受益权。
          </p>
          <p class="text"><span class="space"></span>投保人为与其有劳动关系的劳动者投保本合同的，不得指定被保险人及其近亲属以外的人为受益人。
          </p>
          <p class="text"><span class="space"></span>被保险人为无民事行为能力人或限制民事行为能力人的，可以由其监护人指定受人。
          </p>
          <p class="text"><span class="space"></span>投保人或者被保险人可以变更受益人并书面通知保险人。保险人收到变更受益人的书面通知后，在保险单或其他保险凭证上批注或附贴批单。
          </p>
          <p class="text"><span class="space"></span><span
              class="bold">投保人在指定和变更受益人时，必须经过被保险人同意。</span></p>
          <p class="text"><span class="space"></span>被保险人身故后，有下列情形之一的，保险金作为被保险人的遗产，由保险人依照继承的相关法律规定履行给付保险金的义务：
          </p>
          <p class="text"><span class="space"></span>（一）没有指定受益人，或者受益人指定不明无法确定的；</p>
          <p class="text"><span class="space"></span>（二）受益人先于被保险人身故，没有其他受益人的；</p>
          <p class="text"><span class="space"></span>（三）受益人依法丧失受益权或者放弃受益权，没有其他受益人的。</p>
          <p class="text"><span class="space"></span><span
              class="bold">受益人与被保险人在同一事件中身故，且不能确定身故先后顺序的，推定受益人身故在先。</span>
          </p>
          <p class="text"><span class="space"></span><span
              class="bold">受益人故意造成被保险人身故、伤残、疾病的，或者故意杀害被保险人未遂的，该受益人丧失受益权。</span>
          </p>

          <p class="text bold text-center">保险责任</p>
          <p class="text"><span class="space"></span><span class="bold">第四条</span> 本合同的保险责任分为“必选责任
            ”及“可选责任 ”。投保人在已选择投保“必选责任 ”的前提下，可以选择投保“可选责任
            ”中的一项或多项，<span class="bold">若投保人未投保“必选责任 ”，则不可投保“可选责任 ”。</span>保险责任由投保人在投保时与保险人协商确定，并在保险合同中载明。
          </p>
          <p class="text"><span class="space"></span><span class="bold">第五条</span> 在保险期间内，保险人按约定承担下列保险责任：
          </p>
          <p class="text"><span class="space"></span>（一）必选责任</p>
          <p class="text"><span class="space"></span>1．意外伤害保险责任</p>
          <p class="text"><span class="space"></span>（1）意外身故保险责任</p>
          <p class="text"><span class="space"></span>被保险人因遭受本合同约定的<span class="bold">意外事故</span>，并自事故发生之日起
            180 日内（含第 180 日）因该事故身故的，保险人按约定的意外伤害保险金额扣除已给付的意外伤残保险金（如有）后的余额给付意外身故保险金，<span
                class="bold">对该被保险人的保险责任终止。</span></p>
          <p class="text"><span class="space"></span>（2）意外伤残保险责任</p>
          <p class="text"><span class="space"></span>被保险人因遭受本合同约定的意外事故，并自事故发生之日起 180 日内（含第
            180 日）因该事故造成《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）（国家质量监督检验检疫总局、国家标准化管理委员会发布，《中华人民共和国国家标准批准发布公告 2014 年第
            21
            号》）所列伤残项目的，<span
                class="bold">保险人依照该标准规定的评定原则对伤残项目进行评定，并按评定结果所对应该标准规定的给付比例乘以意外伤害保险金额给付意外伤残保险金。</span>如自该次意外事故发生之日起第
            180 日治疗仍未结束的，按事故发生之日起第 180 日的身体情况进行伤残鉴定，并据此给付意外伤残保险金。</p>
          <p class="text"><span class="space"></span>被保险人因遭受该次意外事故导致的伤残合并前次伤残可达较严重伤残项目的，保险人按较严重项目对应标准的给付比例给付伤残保险金，<span
              class="bold">但应扣除前次伤残程度在《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）对应的伤残保险金。</span></p>
          <p class="text"><span class="space"></span>当同一保险事故造成两处或两处以上伤残时，应首先对各处伤残程度分别进行评定，如果几处伤残等级不同，以最重的伤残等级作为最终的评定结论；如果两处或两处以上伤残等级相同，伤残等级在原评定基础上最多晋升一级，最高晋升至第一级。<span
              class="bold">同一部位和性质的伤残，不应采用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）条文两条或以上或者同一条文两次或以上进行评定。如劳动能力鉴定委员会对属于保险责任的因工致残的伤残等级已有鉴定结论的，保险人按照该鉴定结论认定的伤残等级标准给付意外伤残保险金。</span>
          </p>
          <p class="text"><span class="space"></span><span class="bold"> 被保险人的意外身故保险责任及意外伤残保险责任的累计给付金额以该被保险人的意外伤害保险金额为限，累计给付金额达到其意外伤害保险金额时，对该被保险人的意外身故保险责任及意外伤残保险责任终止。
          </span></p>
          <p class="text"><span class="space"></span>（二）可选责任</p>
          <p class="text"><span class="space"></span>1．<span class="bold">工作期间</span>猝死保险责任</p>
          <p class="text"><span class="space"></span>被保险人在本合同约定的工作期间发生猝死，保险人按其工作期间猝死保险金额给付工作期间猝死保险金，<span
              class="bold">对该被保险人的保险责任终止。</span>
          </p>
          <p class="text"><span class="space"></span>2．工作期间意外身故保险责任</p>
          <p class="text"><span class="space"></span>被保险人在本合同约定的工作期间遭受意外事故，并自事故发生之日起 180
            日内（含第180
            日）因该事故身故的，保险人按其工作期间意外身故保险金额给付工作期间意外身故保险金，<span class="bold">对该被保险人的保险责任终止。</span>
          </p>
          <p class="text"><span class="space"></span>3．非工作期间意外身故保险责任（非法定）
            被保险人在本合同约定的非工作期间遭受意外事故，并自事故发生之日起 180 日内（含第 180
            日）因该事故身故的，保险人按其非工作期间意外身故保险金额给付非工作期间意外身故保险金，<span class="bold">对该被保险人的保险责任终止。</span>
          </p>
          <p class="text"><span class="space"></span>4．工作期间意外伤残保险责任</p>
          <p class="text"><span class="space"></span>被保险人在本合同约定的工作期间遭受意外事故，并自事故发生之日起 180
            日内（含第180
            日）因该事故造成《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）所列伤残类别的，<span class="bold">保险人依照该标准规定的评定原则对伤残类别和等级进行评定，保险人按评定结果所对应该标准规定的给付比例乘以其工作期间意外伤残保险金额给付工作期间意外伤残保险金。</span>如自该次意外事故发生之日起第
            180 日时治疗仍未结束的，按该次意外事故发生之日起第 180 日的身体情况进行伤残鉴定，并据此给付工作期间意外伤残保险金。
          </p>
          <p class="text"><span class="space"></span>被保险人因遭受该次意外事故导致的伤残合并前次伤残可达较严重伤残项目的，保险人按较严重项目对应标准的给付比例给付伤残保险金，<span
              class="bold">但应扣除前次伤残程度在《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）对应的伤残保险金。</span></p>
          <p class="text"><span class="space"></span>当同一保险事故造成两处或两处以上伤残时，应首先对各处伤残程度分别进行评定，如果几处伤残等级不同，以最重的伤残等级作为最终的评定结论；如果两处或两处以上伤残等级相同，伤残等级在原评定基础上最多晋升一级，最高晋升至第一级。<span
              class="bold">同一部位和性质的伤残，不应采用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）条文两条或以上或者同一条文两次或以上进行评定。如劳动能力鉴定委员会对属于保险责任的因工致残的伤残等级已有鉴定结论的，保险人按照该鉴定结论认定的伤残等级标准给付意外伤残保险金。</span>
          </p>
          <p class="text"><span class="space"></span><span class="bold">被保险人的工作期间意外伤残保险责任的累计给付金额以该被保险人的工作期间意外伤残保险金额为限，累计给付金额达到其工作期间意外伤残保险金额时，保险人对该被保险人的该项保险责任终止。</span>
          </p>
          <p class="text"><span class="space"></span>5．非工作期间意外伤残保险责任</p>
          <p class="text"><span class="space"></span>被保险人在本合同约定的非工作期间遭受意外事故，并自事故发生之日起 180
            日内（含第 180
            日）因该事故造成《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）所列伤残类别的，<span class="bold">保险人依照该标准规定的评定原则对伤残类别和等级进行评定，保险人按评定结果所对应该标准规定的给付比例乘以其非工作期间意外伤残保险金额给付非工作期间意外伤残保险金。</span>如自该次意外事故发生之日起第
            180 日时治疗仍未结束的，按该次意外事故发生之日起第 180
            日的身体情况进行伤残鉴定，并据此给付非工作期间意外伤残保险被保险人因遭受该次意外事故导致的伤残合并前次伤残可达较严重伤残项目的，保险人按较严重项目对应标准的给付比例给付伤残保险金，<span
                class="bold">但应扣除前次伤残程度在《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
              16180-2014）对应的伤残保险金。</span></p>
          <p class="text"><span class="space"></span>当同一保险事故造成两处或两处以上伤残时，应首先对各处伤残程度分别进行评定，如果几处伤残等级不同，以最重的伤残等级作为最终的评定结论；如果两处或两处以上伤残等级相同，伤残等级在原评定基础上最多晋升一级，最高晋升至第一级。<span
              class="bold">同一部位和性质的伤残，不应采用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）条文两条或以上或者同一条文两次或以上进行评定。如劳动能力鉴定委员会对属于保险责任的因工致残的伤残等级已有鉴定结论的，保险人按照该鉴定结论认定的伤残等级标准给付意外伤残保险金。</span>
          </p>
          <p class="text"><span class="space"></span><span class="bold">被保险人的非工作期间意外伤残保险责任的累计给付金额以该被保险人的非工作期间意外伤残保险金额为限，累计给付金额达到其非工作期间意外伤残保险金额时，保险人对该被保险人的该项保险责任终止。</span>
          </p>
          <p class="text"><span class="space"></span>6．工作期间火灾意外身故保险责任</p>
          <p class="text"><span class="space"></span>被保险人在本合同约定的工作期间因所处场所遭受火灾发生意外事故，并自事故发生之日起
            180 日内（含第 180
            日）因该事故身故的，保险人按其工作期间火灾意外身故保险金额给付工作期间火灾意外身故保险金，<span class="bold">对该被保险人的保险责任终止。</span>
          </p>
          <p class="text"><span class="space"></span>7．工作期间火灾意外伤残保险责任</p>
          <p class="text"><span class="space"></span>被保险人在本合同约定的工作期间因所处场所遭受火灾发生意外事故，并自事故发生之日起
            180 日内（含第 180
            日）因该事故造成《劳动能力鉴定职工工伤与职业病致残等级》 （GB/T
            16180-2014）所列伤残类别的，<span class="bold">保险人依照该标准规定的评定原则对伤残类别和等级进行评定，保险人按评定结果所对应该标准规定的给付比例乘以其工作期间火灾意外伤残保险金额给付工作期间火灾意外伤残保险金。</span>如自该次意外事故发生之日起第
            180 日时治疗仍未结束的，按该次意外事故发生之日起第 180 日的身体情况进行伤残鉴定，并据此给付工作期间火灾意外伤残保险金。
            被保险人因遭受该次意外事故导致的伤残合并前次伤残可达较严重伤残项目的，保险人按较严重项目对应标准的给付比例给付伤残保险金，<span
                class="bold">但应扣除前次伤残程度在《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
              16180-2014）对应的伤残保险金。</span></p>
          <p class="text"><span class="space"></span>当同一保险事故造成两处或两处以上伤残时，应首先对各处伤残程度分别进行评定，如果几处伤残等级不同，以最重的伤残等级作为最终的评定结论；如果两处或两处以上伤残等级相同，伤残等级在原评定基础上最多晋升一级，最高晋升至第一级。<span
              class="bold">同一部位和性质的伤残，不应采用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）条文两条或以上或者同一条文两次或以上进行评定。如劳动能力鉴定委员会对属于保险责任的因工致残的伤残等级已有鉴定结论的，保险人按照该鉴定结论认定的伤残等级标准给付意外伤残保险金。</span>
          </p>
          <p class="text"><span class="space"></span><span class="bold">被保险人的工作期间火灾意外伤残保险责任的累计给付金额以该被保险人的工作期间火灾意外伤残保险金额为限，累计给付金额达到其工作期间火灾意外伤残保险金额时，保险人对该被保险人的该项保险责任终止。</span>
            <p class="text"><span class="space"></span>8．法定节假日意外身故保险责任</p>
            <p class="text"><span class="space"></span>被保险人在本合同约定的<span class="bold">法定节假日期间</span>遭受意外事故，并自事故发生之日起
              180 日内（含第 180
              日）因该事故身故的，保险人按其法定节假日意外身故保险金额给付法定节假日意外身故保险金，<span class="bold">对该被保险人的保险责任终止。</span>
              <p class="text"><span class="space"></span>9．法定节假日意外伤残保险责任</p>
              <p class="text"><span class="space"></span>被保险人在本合同约定的法定节假日期间遭受意外事故，并自事故发生之日起
                180 日内（含第 180
                日）因该事故造成《劳动能力鉴定职工工伤与职业病致残等级》（GB/T 16180-
                2014）所列伤残类别的，<span class="bold">保险人依照该标准规定的评定原则对伤残类别和等级进行评定，保险人按评定结果所对应该标准规定的给付比例乘以其法定节假日期间意外伤残保险金额给付法定节假日期间意外伤残保险金。</span>如自该次意外事故发生之日起第
                180 日时治疗仍未结束的，按该次意外事故发生之日起第 180 日的身体情况进行伤残鉴定，并据此给付法定节假日期间意外伤残保险金。
                被保险人因遭受该次意外事故导致的伤残合并前次伤残可达较严重伤残项目的，保险人按较严重项目对应标准的给付比例给付伤残保险金，<span
                    class="bold">但应扣除前次伤残程度在《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
              16180-2014）对应的伤残保险金。</span></p>
              <p class="text"><span class="space"></span>当同一保险事故造成两处或两处以上伤残时，应首先对各处伤残程度分别进行评定，如果几处伤残等级不同，以最重的伤残等级作为最终的评定结论；如果两处或两处以上伤残等级相同，伤残等级在原评定基础上最多晋升一级，最高晋升至第一级。<span
                  class="bold">同一部位和性质的伤残，不应采用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）条文两条或以上或者同一条文两次或以上进行评定。如劳动能力鉴定委员会对属于保险责任的因工致残的伤残等级已有鉴定结论的，保险人按照该鉴定结论认定的伤残等级标准给付意外伤残保险金。</span>
              </p>
              <p class="text"><span class="space"></span><span class="bold">被保险人的法定节假日期间意外伤残保险责任的累计给付金额以该被保险人的法定节假日期间意外伤残保险金额为限，累计给付金额达到其法定节假日期间意外伤残保险金额时，保险人对该被保险人的该项保险责任终止。
              </span></p>
              <p class="text"><span class="space"></span>10．烧伤意外伤害保险责任</p>
              <p class="text"><span class="space"></span>（1）烧伤意外身故保险责任</p>
              <p class="text"><span class="space"></span>被保险人遭受烧伤意外事故，并自事故发生之日起 180 日内（含第 180
                日）因该事故身故的，保险人按其烧伤意外伤害保险金额扣除已给付的该被保险人的烧伤意外伤残保险金（如有）后的余额给付烧伤意外身故保险金，<span
                    class="bold">保险人对该被保险人的保险责任终止。</span>
              </p>
              <p class="text"><span class="space"></span>（2）烧伤意外伤残保险责任</p>
              <p class="text"><span class="space"></span>被保险人遭受烧伤意外事故，并自事故发生之日起 180 日内（含第 180
                日）因该事故造成《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
                16180-2014）所列伤残类别的，<span class="bold">保险人依照该标准规定的评定原则对伤残类别和等级进行评定，保险人按评定结果所对应该标准规定的给付比例乘以其烧伤意外伤害保险金额给付烧伤意外伤残保险金。如自该次意外事故发生之日起第
              180 日时治疗仍未结束的，按该次意外事故发生之日起第 180 日的身体情况进行伤残鉴定，并据此给付烧伤意外伤残保险金。</span>
              </p>
              <p class="text"><span class="space"></span>被保险人因遭受该次意外事故导致的伤残合并前次伤残可达较严重伤残项目的，保险人
                按较严重项目对应标准的给付比例给付伤残保险金，<span class="bold">但应扣除前次伤残程度在《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
              16180-2014）对应的伤残保险金。</span></p>
              <p class="text"><span class="space"></span>当同一保险事故造成两处或两处以上伤残时，应首先对各处伤残程度分别进行评定，如果几处伤残等级不同，以最重的伤残等级作为最终的评定结论；如果两处或两处以上伤残等级相同，伤残等级在原评定基础上最多晋升一级，最高晋升至第一级。<span
                  class="bold">同一部位和性质的伤残，不应采用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）条文两条或以上或者同一条文两次或以上进行评定。如劳动能力鉴定委员会对属于保险责任的因工致残的伤残等级已有鉴定结论的，保险人按照该鉴定结论认定的伤残等级标准给付意外伤残保险金。</span>
              </p>
              <p class="text"><span class="space"></span><span class="bold">被保险人的烧伤意外身故保险责任及烧伤意外伤残保险责任的累计给付金额以该被保险人的烧伤意外伤害保险金额为限，累计给付金额达到其烧伤意外伤害保险金额时，对该被保险人的烧伤意外身故保险金及烧伤意外伤残保险责任终止。
            </span></p>
              <p class="text"><span class="space"></span>11．燃气意外伤害保险责任</p>
              <p class="text"><span class="space"></span>（1）燃气意外身故保险责任</p>
              <p class="text"><span class="space"></span>被保险人遭受<span class="bold">民用燃气意外事故</span>，并自事故发生之日起
                180 日内（含第 180
                日）因该事故身故的，保险人按其燃气意外伤害保险金额扣除已给付的该被保险人的燃气意外伤残保险金（如有）后的余额给付燃气意外身故保险金，<span
                    class="bold">保险人对该被保险人的保险责任终止。</span>
              </p>
              <p class="text"><span class="space"></span>（2）燃气意外伤残保险责任</p>
              <p class="text"><span class="space"></span>被保险人遭受民用燃气意外事故，并自事故发生之日起 180 日内（含第
                180
                日）因该事故造成《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
                16180-2014）所列伤残类别的，
                <span
                    class="bold">保险人依照该标准规定的评定原则对伤残类别和等级进行评定，保险人按评定结果所对应该标准规定的给付比例乘以其燃气意外伤害保险金额给付燃气意外伤残保险金。</span>如自该次意外事故发生之日起第
                180 日时治疗仍未结束的，按该次意外事故发生之日起第 180 日的身体情况进行伤残鉴定，并据此给付燃气意外伤残保险金。
              </p>
              <p class="text"><span class="space"></span>
                被保险人因遭受该次意外事故导致的伤残合并前次伤残可达较严重伤残项目的，保险人按较严重项目对应标准的给付比例给付伤残保险金，<span
                    class="bold">但应扣除前次伤残程度在《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
              16180-2014）对应的伤残保险金。</span></p>
              <p class="text"><span class="space"></span>当同一保险事故造成两处或两处以上伤残时，应首先对各处伤残程度分别进行评定，如果几处伤残等级不同，以最重的伤残等级作为最终的评定结论；如果两处或两处以上伤残等级相同，伤残等级在原评定基础上最多晋升一级，最高晋升至第一级。<span
                  class="bold">同一部位和性质的伤残，不应采用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）条文两条或以上或者同一条文两次或以上进行评定。如劳动能力鉴定委员会对属于保险责任的因工致残的伤残等级已有鉴定结论的，保险人按照该鉴定结论认定的伤残等级标准给付意外伤残保险金。</span>
              </p>
              <p class="text"><span class="space"></span><span class="bold">被保险人的燃气意外身故保险责任及燃气意外伤残保险责任的累计给付金额以该被保险人的燃气意外伤害保险金额为限，累计给付金额达到其燃气意外伤害保险金额时，对该被保险人的燃气意外身故保险责任及燃气意外伤残保险责任终止。
            </span></p>
              <p class="text"><span class="space"></span> 12．食物中毒意外身故或全残保险责任</p>
              <p class="text"><span class="space"></span>（1）食物中毒意外身故保险责任</p>
              <p class="text"><span class="space"></span>被保险人发生<span class="bold">食物中毒</span>意外事故，并自事故发生之日起
                180 日内（含第 180
                日）因该事故身故的，保险人按其食物中毒意外身故或全残保险金额给付食物中毒意外身故保险金，<span class="bold">对该被保险人的保险责任终止。</span>
              </p>
              <p class="text"><span class="space"></span>（2）食物中毒意外全残保险责任</p>
              <p class="text"><span class="space"></span>被保险人发生食物中毒意外事故，并自事故发生之日起 180 日内（含第
                180
                日）因该事故<span class="bold">全残</span>的，保险人按其食物中毒意外身故或全残保险金额给付食物中毒意外全残保险金。如自事故发生之日起第
                180
                日时治疗仍未结束的，按该次事故发生之日起第 180 日的身体情况进行全残鉴定，并据此给付食物中毒意外全残保险金。给付食物中毒意外全残保险金后，
                <span class="bold">保险人对该被保险人的该项保险责任终止。</span></p>
              <p class="text"><span class="space"></span> <span class="bold">食物中毒意外身故保险责任和食物中毒意外全残保险责任仅给付其中一项，给付金额以食物中毒意外身故或全残保险金额为限。
          </span></p>
              <p class="text"><span class="space"></span> 13．特定场所意外伤害保险责任</p>
              <p class="text"><span class="space"></span>（1）特定场所意外身故保险责任</p>
              <p class="text"><span class="space"></span>被保险人在本合同约定的<span class="bold">特定场所</span>内遭受意外事故，并自事故发生之日起
                180
                日内（含第 180
                日）因该事故身故的，保险人按其特定场所意外伤害保险金额扣除已给付的该被保险人的特定场所意外伤残保险金（如有）后的余额给付特定场所意外身故保险金，<span
                    class="bold">对该被保险人的保险责任终止。</span>
              </p>
              <p class="text"><span class="space"></span> （2）特定场所意外伤残保险责任</p>
              <p class="text"><span class="space"></span>被保险人因在本合同约定的特定场所内遭受意外事故，并自事故发生之日起
                180 日内（含第 180
                日）因该事故造成《劳动能力鉴定职工工伤与职业病致残等级》（GB/T 16180-
                2014）所列伤残类别的，<span class="bold">保险人依照该标准规定的评定原则对伤残类别和等级进行评定，保险人按评定结果所对应该标准规定的给付比例乘以其特定场所意外伤害保险金额给付特定场所意外伤残保险金。</span>如自该次意外事故发生之日起第
                180 日时治疗仍未结束的，按该次意外事故发生之日起第 180 日的身体情况进行伤残鉴定，并据此给付特定场所意外伤残保险金。
              </p>
              <p class="text"><span class="space"></span>
                被保险人因遭受该次意外事故导致的伤残合并前次伤残可达较严重伤残项目的，保险人按较严重项目对应标准的给付比例给付伤残保险金，<span
                    class="bold">但应扣除前次伤残程度在《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
              16180-2014）对应的伤残保险金。</span></p>
              <p class="text"><span class="space"></span>当同一保险事故造成两处或两处以上伤残时，应首先对各处伤残程度分别进行评定，如果几处伤残等级不同，以最重的伤残等级作为最终的评定结论；如果两处或两处以上伤残等级相同，伤残等级在原评定基础上最多晋升一级，最高晋升至第一级。<span
                  class="bold">同一部位和性质的伤残，不应采用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）条文两条或以上或者同一条文两次或以上进行评定。如劳动能力鉴定委员会对属于保险责任的因工致残的伤残等级已有鉴定结论的，保险人按照该鉴定结论认定的伤残等级标准给付意外伤残保险金。</span>
              </p>
              <p class="text"><span class="space"></span><span class="bold">被保险人的特定场所意外身故保险责任及特定场所意外伤残保险责任的累计给付金额以该被保险人的特定场所意外伤害保险金额为限，累计给付金额达到其特定场所意外伤害
            保险金额时，保险人对该被保险人的特定场所意外身故保险金及特定场所意外伤残保险责任终止。</span></p>
              <p class="text"><span class="space"></span>14．特定场景意外伤害保险责任</p>
              <p class="text"><span class="space"></span>（1）特定场景意外身故保险责任</p>
              <p class="text"><span class="space"></span>被保险人在本合同约定的特定场景内遭受意外事故，并自事故发生之日起
                180
                日内（含第 180
                日）因该事故身故的，保险人按其<span class="bold">特定场景</span>意外伤害保险金额扣除已给付的该被保险人的特定场景意外伤残保险金（如有）后的余额给付特定场景意外身故保险金，<span
                    class="bold">对该被保险人的保险责任终止。</span>
              </p>
              <p class="text"><span class="space"></span>（2）特定场景意外伤残保险责任</p>
              <p class="text"><span class="space"></span>被保险人因在本合同约定的特定场景内遭受意外事故，并自事故发生之日起
                180 日内（含第 180
                日）因该事故造成《劳动能力鉴定职工工伤与职业病致残等级》（GB/T 16180-
                2014）所列伤残类别的，<span class="bold">保险人依照该标准规定的评定原则对伤残类别和等级进行评定，保险人按评定结果所对应该标准规定的给付比例乘以其特定场景意外伤害保险金额给付特定场景意外伤残保险金。如自该次意外事故发生之日起第
              180 日时治疗仍未结束的，按该次意外事故发生之日起第 180 日的身体情况进行伤残鉴定，并据此给付特定场景意外伤残保险金。</span>
              </p>
              <p class="text"><span class="space"></span>被保险人因遭受该次意外事故导致的伤残合并前次伤残可达较严重伤残项目的，保险人按较严重项目对应标准的给付比例给付伤残保险金，<span
                  class="bold">但应扣除前次伤残程度在《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）对应的伤残保险金。</span></p>
              <p class="text"><span class="space"></span>当同一保险事故造成两处或两处以上伤残时，应首先对各处伤残程度分别进行评定，如果几处伤残等级不同，以最重的伤残等级作为最终的评定结论；如果两处或两处以上伤残等级相同，伤残等级在原评定基础上最多晋升一级，最高晋升至第一级。<span
                  class="bold">同一部位和性质的伤残，不应采用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）条文两条或以上或者同一条文两次或以上进行评定。如劳动能力鉴定委员会对属于保险责任的因工致残的伤残等级已有鉴定结论的，保险人按照该鉴定结论认定的伤残等级标准给付意外伤残保险金。</span>
              </p>
              <p class="text"><span class="space"></span><span class="bold">被保险人的特定场景意外身故保险责任及特定场景意外伤残保险责任的累计给付金额以该被保险人的特定场景意外伤害保险金额为限，累计给付金额达到其特定场景意外伤害保险金额时，保险人对该被保险人的特定场景意外身故保险责任及特定场景意外伤残保险责任终止。
            </span></p>
              <p class="text"><span class="space"></span>15．见义勇为意外伤害保险责任</p>
              <p class="text"><span class="space"></span>（1）见义勇为意外身故保险责任</p>
              <p class="text"><span class="space"></span>被保险人因<span class="bold">见义勇为行为</span>遭受意外事故，并自事故发生之日起
                180 日内（含第
                180
                日）因该事故身故的，保险人按其见义勇为意外伤害保险金额扣除已给付的该被保险人的见义勇
                为意外伤残保险金（如有）后的余额给付见义勇为意外身故保险金，<span
                    class="bold">对该被保险人的保险责任终止。</span></p>
              <p class="text"><span class="space"></span>（2）见义勇为意外伤残保险责任</p>
              <p class="text"><span class="space"></span> 被保险人因见义勇为行为遭受意外事故，并自事故发生之日起 180
                日内（含第
                180 日）
                因该事故造成《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
                16180-2014）所列伤残类别的，<span class="bold">保险人依照该标准规定的评定原则对伤残类别和等级进行评定，保险人按评定结果所对应该标准规定的给付比例乘以其见义勇为意外伤害保险金额给付见义勇为意外伤残保险金。</span>如自该次意外事故发生之日起第
                180 日时治疗仍未结束的，按该次意外事故发生之日起第 180 日的身体情况进行伤残鉴定，并据此给付见义勇为意外伤残保险金。
              </p>
              <p class="text"><span class="space"></span>被保险人因遭受该次意外事故导致的伤残合并前次伤残可达较严重伤残项目的，保险人按较严重项目对应标准的给付比例给付伤残保险金，<span
                  class="bold">但应扣除前次伤残程度在《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）对应的伤残保险金。</span></p>
              <p class="text"><span class="space"></span>当同一保险事故造成两处或两处以上伤残时，应首先对各处伤残程度分别进行评定，如果几处伤残等级不同，以最重的伤残等级作为最终的评定结论；如果两处或两处以上伤残等级相同，伤残等级在原评定基础上最多晋升一级，最高晋升至第一级。<span
                  class="bold">同一部位和性质的伤残，不应采用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
            16180-2014）条文两条或以上或者同一条文两次或以上进行评定。如劳动能力鉴定委员会对属于保险责任的因工致残的伤残等级已有鉴定结论的，保险人按照该鉴定结论认定的伤残等级标准给付意外伤残保险金。</span>
              </p>
              <p class="text"><span class="space"></span><span class="bold">被保险人的见义勇为意外身故保险责任及见义勇为意外伤残保险责任的累计给付金额以该被保险人的见义勇为意外伤害保险金额为限，累计给付金额达到其见义勇为意外伤害保险金额时，保险人对该被保险人的见义勇为意外身故保险金及见义勇为意外伤残保险责任终止。
              </span></p>
              <p class="text"><span class="space"></span> 16．疫苗接种意外身故保险责任</p>
              <p class="text"><span class="space"></span>被保险人在本合同约定的<span
                  class="bold">疫苗接种单位</span>由<span class="bold">合格的疫苗接种人员</span>实施接种<span
                  class="bold">疫苗</span>中或实施接种疫苗后发生机体组织器官、功能损害的<span
                  class="bold">预防接种异常反应</span>，并自该事故发生之日起
                180日内（含第 180 日）以该事故为直接原因导致身故的，保险人按其疫苗接种意外身故保险金额给付疫苗接种意外身故保险金，<span
                    class="bold">对该被保险人的保险责任终止。</span>
                <p class="text"><span class="space"></span>

                  <p class="text text-center"><span class="bold">责任免除</span></p>
                  <p class="text"><span class="space"></span><span class="bold">第六条  因下列情形之一，造成被保险人身故、伤残的，保险人不承担给付意外伤害保险金、猝死保险金、工作期间猝死保险金、工作期间意外身故保险金、非工作期间意外身故保险金、工作期间意外伤残保险金、非工作期间意外伤残保险金、工作期间火灾意外身故保险金、工作期间火灾意外伤残保险金、法定节假日意外身故保险金、法定节假日意外伤残保险金、烧伤意外伤害保险金、燃气意外伤害保险金、食物中毒意外身故或全残保险金、特定场所意外伤害保险金、特定场景意外伤害保险金、见义勇为意外伤害保险金的责任：
              </span></p>
                  <div class="bold">
                    <p class="text"><span class="space"></span><span
                        class="bold">1．投保人对被保险人的故意杀害、故意伤害；</span></p>
                    <p class="text"><span class="space"></span>2．被保险人故意自伤、故意犯罪或者抗拒依法采取的刑事强制措施或自杀，但被保险人自杀时为无民事行为能力人的除外；
                    </p>
                    <p class="text"><span class="space"></span>3．被保险人殴斗、醉酒，吸食或注射毒品；</p>
                    <p class="text"><span class="space"></span>4．被保险人酒后驾驶机动车、无合法有效驾驶证驾驶机动车，或驾驶无合法有效行驶证的机动车；
                    </p>
                    <p class="text"><span class="space"></span>5．战争、军事冲突、恐怖袭击、暴乱或武装叛乱；</p>
                    <p class="text"><span class="space"></span>6．核爆炸、核辐射或核污染；</p>
                    <p class="text"><span class="space"></span>7．被保险人因妊娠（含宫外孕）、流产、分娩（含剖宫产）、疾病、中暑导致的伤害；
                    </p>
                    <p class="text"><span class="space"></span>8．被保险人因医疗事故、药物过敏或精神和行为障碍（依照世界卫生组织《疾病和有关健康问题的国际统计分类》第十次修订版（ICD-10）确定）导致的伤害；
                    </p>
                    <p class="text"><span class="space"></span>9．被保险人未遵医嘱，私自使用药物，但按使用说明的规定使用非处方药不在此限；
                    </p>
                    <p class="text"><span class="space"></span>10．猝死（不适用于猝死保险责任）；</p>
                    <p class="text"><span class="space"></span>11．细菌或病毒感染（因意外事故导致的伤口发生感染者除外） ;
                    </p>
                    <p class="text"><span class="space"></span>12．被保险人参加潜水、跳伞、攀岩、蹦极、驾驶滑翔机或滑翔伞、探险、摔跤、武术比赛、特技表演、赛马、赛车等高风险运动；
                    </p>
                    <p class="text"><span class="space"></span>13．既往症及其并发症（仅适用于猝死保险责任）。</p>
                    <p class="text"><span class="space"></span>14．未经燃气公司同意，擅自拆卸、接装或移动燃气设备、私自接装以燃气为能源的生活器具等违规操作行为所导致的燃气事故（仅适用于燃气意外伤害保险责任）。
                    </p>
                    <p class="text"><span class="space"></span>发生上述第 1
                      项情形导致被保险人身故的，保险人对该被保险人保险责任终止，保险人向投保人之外的被保险人的继承人退还该被保险人相应的现金价值。
                    </p>
                    <p class="text"><span class="space"></span>发生上述其他情形导致被保险人身故的，保险人对该被保险人保险责任终止，保险人向投保人退还该被保险人相应的现金价值。
                    </p>
                    <p class="text"><span class="space"></span>第七条 因下列情形之一导致被保险人身故的，保险人不承担给付疫苗接种意外身故保险金：
                    </p>
                    <p class="text"><span class="space"></span>1．投保人对被保险人的故意杀害、故意伤害；</p>
                    <p class="text"><span class="space"></span>2．被保险人故意自伤、故意犯罪或者抗拒依法采取的刑事强制措施或自杀，但被保险人自杀时为无民事行为能力人的除外；
                    </p>
                    <p class="text"><span class="space"></span>3. 在不具有卫生主管部门要求的预防接种条件的单位接种疫苗；
                    </p>
                    <p class="text"><span class="space"></span> 4．实施接种的医疗卫生人员未参加卫生主管部门组织的预防接种专业培训或培训考核不合格；
                    </p>
                    <p class="text"><span class="space"></span>5．疫苗质量不合格的；</p>
                    <p class="text"><span class="space"></span>6. 因疫苗本身特性引起的接种后一般反应；</p>
                    <p class="text"><span class="space"></span>7. 因接种单位违反预防接种工作规范、免疫程序、疫苗使用指导原则或接种方案给被保险人造成损害的；
                    </p>
                    <p class="text"><span class="space"></span>8. 被保险人因医疗事故、药物过敏导致的伤害；</p>
                    <p class="text"><span class="space"></span>9.
                      被保险人有疫苗说明书规定的接种禁忌，在接种前被保险人或者其监护人未如实提供被保险人的健康状况和接种禁忌等情况，接种后被保险人原有疾病急性复发或者病情加重导致被保险人身故；
                    </p>
                    <p class="text"><span class="space"></span>10．猝死；</p>
                    <p class="text"><span class="space"></span>11．细菌或病毒感染（因意外事故导致的伤口发生感染者除外）；
                    </p>
                    <p class="text"><span class="space"></span>12．被保险人在接种时正处于某种疾病的潜伏期或者前驱期，接种后偶合发病；
                    </p>
                    <p class="text"><span class="space"></span>13．因心理因素发生的个体或者群体的心因性反应；</p>
                    <p class="text"><span class="space"></span>发生上述第 1
                      项情形导致被保险人身故的，保险人对该被保险人保险责任终止，保险人向投保人之外的被保险人的继承人退还该被保险人相应的现金价值。
                    </p>
                    <p class="text"><span class="space"></span>发生上述其他情形导致被保险人身故的，保险人对该被保险人保险责任终止，保险人向投保人退还本合同的现金价值。
                    </p>
                  </div>


                  <p class="text bold text-center">保险金额与给付比例</p>
                  <p class="text"><span class="space"></span><span class="bold">第八条</span> 保险金额是保险人承担给付保险责任的最高限额。
                  </p>
                  <p class="text"><span class="space"></span>本合同的保险金额、给付比例由投保人、保险人在订立保险合同时协商确定，
                    并在保险合同中载明。</p>
                  <p class="text"><span class="space"></span><span class="bold">第九条 为未成年子女投保的人身保险，因被保险人身故给付的保险金总和不得超过国务院保险监督管理机构规定的限额。
              </span></p>

                  <p class="text text-center"><span class="bold">保险期间</span></p>
                  <p class="text"><span class="space"></span> 第十条
                    <span class="bold">第九条本保险产品遵循不保证续保条款：</span>本产品保险期间为一年（或不超过一年）。保险期间届满，投保人需要重新向保险人申请投保本产品，经保险人同意，交纳保险费，获得新的保险合同。
                  </p>


                  <p class="text text-center"><span class="bold">保险人义务</span></p>
                  <p class="text"><span class="space"></span><span class="bold">第十一条</span>订立本合同时，保险人应当向投保人说明本合同的内容。对保险合同中免除保险人责任的条款，保险人在订立合同时应当在投保单、保险单或者其他保险凭证上做出足以引起投保人注意的提示，并对该条款的内容以书面或者口头形式向投保人做出明确说明。未作提示或者明确说明的，该条款不产生效力。
                  </p>
                  <p class="text"><span class="space"></span><span class="bold">第十二条</span>
                    本合同成立后，保险人应当及时向投保人签发保险单或其他保险凭证。
                  </p>
                  <p class="text"><span class="space"></span><span class="bold">第十三条</span>
                    保险人认为被保险人提供的有关索赔的证明和资料不完整的，应当及时一次性通知投保人、被保险人补充提供。
                  </p>
                  <p class="text"><span class="space"></span><span class="bold">第十四条</span>
                    保险人在收到被保险人给付保险金的请求后，将在五日内作出核定；情形复杂的，在三十日内（但投保人、被保险人或者受益人补充提供有关证明和资料的期间不计算在内）作出核定。另有约定的按约定内容执行。
                  </p>
                  <p class="text"><span class="space"></span>对属于保险责任的，保险人在与受益人达成给付保险金的协议后十日内，履行给付保险金义务。
                  </p>
                  <p class="text"><span class="space"></span>保险人未及时履行前款规定义务的，除支付保险金外，保险人会赔偿受益人因此受到的损失。若保险人在收到被保险人给付保险金的请求后第三十日仍未作出核定，
                    除支付保险金外，保险人将从第三十一日起按超过日数赔偿受益人因此受到的利息损失。如保险人要求投保人、被保险人或者受益人补充提供有关证明和资料的，
                    上述三十日期间会扣除投保人、被保险人或者受益人补充提供有关证明和资料期间，扣除期间自保险人作出的通知到达投保人、被保险人或者受益人之日起，至投保人、被保险人或者受益人按照通知要求补充提供的有关证明和资料到达保险人之日止。利息按照中国人民银行公布的同期金融机构人民币活期存款基准利率计算单利。
                  </p>
                  <p class="text"><span class="space"></span>对不属于保险责任的，保险人自作出核定之日起三日内向受益人发出拒绝给付保险金通知书并说明理由。
                  </p>
                  <p class="text"><span class="space"></span><span class="bold">第十五条</span>
                    保险人自收到给付保险金的请求和有关证明、资料之日起六十日内，
                  </p>
                  <p class="text"><span class="space"></span>对其赔偿的数额不能确定的，应当根据已有证明和资料可以确定的数额先予支付；保险人最终确定给付的数额后，应当支付相应的差额。
                  </p>


                  <p class="text text-center"><span class="bold">投保人、被保险人义务</span>
                  </p>
                  <p class="text"><span class="space"></span>第十六条
                    若投保人选择一次性支付保险费的，投保人应当在投保时一次性交清保险费。若投保人选择分期支付保险费的，在支付首期保险费后，投保人应当在保险费约定支付日支付其余各期的保险费。若未按时支付的，
                    投保人应于保险人催告投保人支付保险费之日起 30 日的期限内支付当期保险费。上述期限内发生的保险事故，保险
                    人仍会承担保险责任，<span class="bold">但在给付保险金时有权扣减投保人对应的欠交保险费。</span></p>
                  <p class="text"><span class="space"></span>投保人在上述期限内未支付保险费的，则本合同自上述期限届满的次日零时起效力中止。
                  </p>
                  <p class="text"><span class="space"></span><span
                      class="bold">如果被保险人在合同效力中止期间发生保险事故的，保险人不承担保险责任。</span>
                  </p>
                  <p class="text"><span class="space"></span>合同效力依照前款约定中止的，经投保人与保险人协商并达成协议，在投保人补交保险费后，合同效力恢复，保险人继续承担保险责任至保险期间届满；合同效力至保险期间届满时仍未恢复的，本合同于保险期间届满时终止。
                  </p>
                  <p class="text"><span class="space"></span><span class="bold">第十七条</span>
                    订立保险合同，保险人就被保险人的有关情况提出询问的，投保人应当如实告知，并如实填写投保单。
                  </p>
                  <p class="text"><span class="space"></span><span class="bold">如果投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响保险人决定是否同意承保或者提高保险费率的，保险人有权解除本合同或终止对该被保险人的保险责任。</span>
                  </p>
                  <p class="text"><span class="space"></span>前款规定的合同解除权，自保险人知道有解除事由之日起，超过三十日不行使而消灭。
                  </p>
                  <p class="text"><span class="space"></span><span class="bold">如果投保人故意不履行如实告知义务，对于解除本合同或终止对该被保险人的保险责任前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
              </span></p>
                  <p class="text"><span class="space"></span><span class="bold">如果投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于解除本合同或终止对该被保险人的保险责任前发生的保险事故，保险人不承担给付保险金的责任，但应当退还保险费。
              </span></p>
                  <p class="text"><span class="space"></span>保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除本合同或终止对该被保险人的保险责任；发生保险事故的，保险人承担给付保险金的责任。
                  </p>
                  <p class="text"><span class="space"></span><span class="bold">第十八条</span> 投保人的住所、通讯地址或电话等联系方式变更时，
                    应及时以书面形式或双方认可的其他形式通知保险人，投保人未以书面形式或双方认可的其他形式通知的，保险人按本合同注明的最后住所或通讯地址发送的有关通知，均视为已送达给投保人。
                  </p>
                  <p class="text"><span class="space"></span><span class="bold">第十九条</span> 投保人、被保险人或受益人应当在知道保险事故后
                    10
                    日内通知保险人。</p>
                  <p class="text"><span class="space"></span><span class="bold">如果投保人、被保险人或受益人故意或者因重大过失未及时通知，或者拒绝或者妨碍保险人进行事故调查，致使保险事故的性质、原因、损失程度等难以确定的，保险人对无
                法确定的部分，不承担给付保险金的责任，</span>但保险人通过其他途径已经及时知道或者应当及时知道保险事故发生或者虽未及时通知但不影响保险人确定保险事故的性质、原因、损失程度的除外。
                  </p>


                  <p class="text text-center"><span class="bold">危险变更通知</span></p>
                  <p class="text"><span class="space"></span><span class="bold">第二十条</span>
                    在本合同保险期间内，投保人变更投保人投保时向保险人告知的职业或工种时，投保人应于
                    10 日内以书面形式通知保险人。</p>
                  <p class="text"><span class="space"></span>投保人所变更的职业或工种，依照保险人职业分类其危险程度降低时，保险人自接到通知之日起，根据其危险程度变更后的应收保险费与实收保险费的差额退还相应的现金价值；其危险程度增加时，保险人自接到通知之日起，根据其危险程度变更情况增收相应的未满期保险费，对于尚未收取的保险费按照其危险程度变更情况对应的保险费收取。<span
                      class="bold">投保人所变更的职业或工种超出保险人承保范围的，保险人对投保人的保险责任自接到通知之日起终止，并退还现金价值。
              </span></p>
                  <p class="text"><span class="space"></span>投保人所变更的职业或工种，依照保险人职业或工种分类其危险程度增加而未依上述约定通知保险人，且发生保险事故的，<span
                      class="bold">保险人按实收保险费与应收保险费的相对比例计算给付保险金。但投保人所变更的职业或工种超出保险人承保范围的，保险人不承担给付保险金的责任。</span>
                  </p>


                  <p class="text text-center"><span class="bold">保险金申请与给付</span></p>
                  <p class="text"><span class="space"></span><span class="bold">第二十一条</span></p>
                  <p class="text"><span class="space"></span>意外身故保险金、猝死保险金、工作期间猝死保险金、工作期间意外身故保险金、非工作期间意外身故保险金、工作期间火灾意外身故保险金、法定节假日意外身故保险金、烧伤意外身故保险金、燃气意外身故保险金、食物中毒意外身故保险金、特定场所意外身故保险金、特定场景意外身故保险金、见义勇为意外身故保险金、疫苗接种意外身故保险金的申请
                  </p>
                  <p class="text"><span class="space"></span>由保险金申请人填写相应保险金给付申请书，并提供下列证明和资料：
                  </p>
                  <p class="text"><span class="space"></span>1．保险合同或保险单号；</p>
                  <p class="text"><span class="space"></span>2．被保险人及申请人的有效身份证件；</p>
                  <p class="text"><span class="space"></span>3．公安部门或医疗机构出具的被保险人死亡证明书。若被保险人为宣告死亡，保险金申请人应提供人民法院出具的宣告死亡证明文件；如本合同要求的死亡证明可证明死亡原因的，可用死亡证明，<span
                      class="bold">否则，保险金申请人应提供司法鉴定机构或保险人认可的机构出具的死因鉴定报告；</span>
                  </p>
                  <p class="text"><span class="space"></span>4．申请工作期间火灾意外身故保险金时，需提供由公安消防部门或有资质的其他相关部门出具火灾事故相关证明；
                  </p>
                  <p class="text"><span class="space"></span>5．申请食物中毒意外身故保险金时，需提供食品卫生监督部门、国家卫生行政部门认定的医疗机构、公安部门或有资质的其他相关机构出具的被保险人的食物中毒证明；
                  </p>
                  <p class="text"><span class="space"></span>6．申请见义勇为意外身故保险金时，需提供由双方认可的机构（包括但不限于公安部门、当地人民政府、见义勇为基金会或协会）出具的相关认定证明；
                  </p>
                  <p class="text"><span class="space"></span>7．所能提供的与确认保险事故的性质、原因等有关的其他证明和资料。
                  </p>
                  <p class="text"><span class="space"></span> 8. 若保险金申请人委托他人申请的，还应提授权委托书原件、委托人和受托人的身份证明等相关证明文件。
                  </p>
                  <p class="text"><span class="space"></span><span class="bold">第二十二条</span></p>
                  <p class="text"><span class="space"></span>意外伤残保险金、工作期间意外伤残保险金、非工作期间意外伤残保险金、工作期间火灾意外伤残保险金、法定节假日意外伤残保险金、烧伤意外伤残保险金、燃气意外伤残保险金、食物中毒意外全残保险金、特定场所意外伤残保险金、特定场景意外伤残保
                    险金、见义勇为意外伤残保险金的申请</p>
                  <p class="text"><span class="space"></span>由保险金申请人填写相应保险金给付申请书，并提供下列证明和资料：
                  </p>
                  <p class="text"><span class="space"></span>1．保险合同或保险单号；</p>
                  <p class="text"><span class="space"></span>2．被保险人及申请人的有效身份证件；</p>
                  <p class="text"><span class="space"></span>3．具有对应的合法鉴定资质的司法鉴定机构根据《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
                    16180-2014）出具的伤残程度鉴定书；</p>
                  <p class="text"><span class="space"></span>4．申请工作期间火灾意外伤残保险金时，需提供由公安消防部门或有资质的其他相关部门出具火灾事故相关证明；
                  </p>
                  <p class="text"><span class="space"></span>5．申请食物中毒意外全残保险金时，需提供食品卫生监督部门、国家卫生行政部门认定的医疗机构、公安部门或有资质的其他相关机构出具的被保险人的食物中毒证明；
                  </p>
                  <p class="text"><span class="space"></span>6．申请见义勇为意外伤残保险金时，需提供由双方认可的机构（包括但不限于公安部门、当地人民政府、见义勇为基金会或协会）出具的相关认定证明；
                  </p>
                  <p class="text"><span class="space"></span>7．所能提供的与确认保险事故的性质、原因、伤害程度等有关的其他证明和资料。
                  </p>
                  <p class="text"><span class="space"></span>8. 若保险金申请人委托他人申请的，还应提授权委托书原件、委托人和受托人的身份证明等相关证明文件。
                  </p>
                  <p class="text"><span class="space"></span>如投保人与保险人对需提供证明、资料有其他约定的，按约定执行。
                  </p>
                  <p class="text"><span class="space"></span>保险金作为被保险人遗产时，必须提供可证明合法继承权的相关权利文件。
                  </p>


                  <p class="text text-center"><span class="bold">争议处理和法律适用</span>
                  </p>
                  <p class="text"><span class="space"></span><span class="bold">第二十三条</span>
                    因履行本合同发生的争议，由当事人协商解决。协商不成的，
                  </p>
                  <p class="text"><span class="space"></span>提交保险单载明的仲裁机构仲裁；保险单未载明仲裁机构且争议发生后未达成仲裁协议的，依法向中华人民共和国境内<span
                      class="bold">（不包括港澳台地区）</span>人民法院起诉。
                  </p>
                  <p class="text"><span class="space"></span><span class="bold">第二十四条</span> 本合同的争议处理适用中华人民共和国法律<span
                      class="bold">（不包括港澳台地区法律）。</span>
                  </p>


                  <p class="text text-center"><span class="bold">其他事项</span></p>
                  <p class="text"><span class="space"></span><span class="bold">第二十五条</span> 投保人和保险人可以协商变更合同内容。
                  </p>
                  <p class="text"><span class="space"></span>变更保险合同的，应当由保险人在保险单或者其他保险凭证上批注或附贴批单，或者投保人和保险人订立变更的书面协议。
                  </p>
                  <p class="text"><span class="space"></span><span class="bold">第二十六条</span>
                    在本合同成立后，投保人可以书面形式通知保险人解除合同，<span
                        class="bold">但保险人已根据本合同约定给付保险金的除外。</span>
                  </p>
                  <p class="text"><span class="space"></span>投保人解除本合同时，应提供下列证明文件和资料：</p>
                  <p class="text"><span class="space"></span>（一）保险合同解除申请书；</p>
                  <p class="text"><span class="space"></span>（二）保险合同；</p>
                  <p class="text"><span class="space"></span>（三）投保人的有效身份证件。</p>
                  <p class="text"><span class="space"></span><span class="bold">投保人要求解除本合同，
                自保险人接到保险合同解除申请书之时起，本合同的效力终止。保险人收到上述证明文件和资料之日起</span>
              30 日内退还保险单的现金价值。</p>
                <p class="text"><span class="space"></span><span class="bold">第二十七条 被保险人变动</span></p>
                <p class="text"><span class="space"></span>（一）投保人因参保的团体成员变动需增加的，应书面通知保险人，保险人审核同意并收取相应保险费后，按照保险合同的约定承担保险责任。
                </p>
                <p class="text"><span class="space"></span><span class="bold">（二）本合同有效期内，投保人因参加本保险的团体成员离职或丧失保险资格需减少被保险人的，应书面通知保险人，保险人对相应被保险人（含该被保险人及其父母、配偶和子女）的保险责任自该被保险人离职或丧失保险资格之日起终止，保险人应退还相应被保险人的现金价值。
              </span></p>
                <p class="text text-center"><span class="bold">释义</span></p>
                <p class="text"><span class="space"></span><span class="bold">【团体】</span></p>
                <p class="text"><span class="space"></span>指中华人民共和国境内具有 3 名以上（含 3
                  名）成员且非因购买保险而组织的合法团体。包括法人、非法人组织以及其他不以购买保险为目的而组成的团体。团体属于其他不以购买保险为目的而组成的团体的，投保人可以是团体中的自然人。
                </p>
                <p class="text"><span class="space"></span><span class="bold">【成员】</span></p>
                <p class="text"><span class="space"></span>团体为机关或企事业单位的，成员指该团体中身体健康、正常工作的在职员工；团体为社会团体的，成员指该团体的会员以及正式工作人员；团体为其他不以购买保险为目的而组成的团体的，成员指团体中的各自然人。
                </p>
                <p class="text"><span class="space"></span>其中，在职员工指每周正常工作时间不少于 30
                  小时、且与投保单位存在劳动关系的全职员工，不包括临时工。</p>
                <p class="text"><span class="space"></span>另有约定的按约定内容执行。参保的人员必须符合法律及监管规定的要求。
                </p>
                <p class="text"><span class="space"></span><span class="bold">【配偶】</span></p>
                <p class="text"><span class="space"></span>指投保时与参加本保险的被保险人存在合法婚姻关系的丈夫或妻子。
                </p>

                <p class="text"><span class="space"></span><span class="bold">【子女】</span></p>
                <p class="text"><span class="space"></span>指投保时被保险人的出生30
                  日以上（并且已健康出院的），未满23周岁且未婚的子女（包括婚生子女、非婚生子女、合法收养的子女和有扶养关系的继子女）。
                </p>
                <p class="text"><span class="space"></span><span class="bold">【意外事故】</span></p>
                <p class="text"><span class="space"></span>指外来的、突发的、非本意的和非疾病的导致被保险人的身体受到伤害的客观事件。
                </p>
                <p class="text"><span class="space"></span><span class="bold">【猝死】</span></p>
                <p class="text"><span class="space"></span>指表面健康的人因潜在疾病、机能障碍在出现症状后 24
                  小时内发生的非暴力性突然死亡。<span
                      class="bold">该急性症状是被保险人在保险合同生效之前未曾接受诊断或治疗且在保险合同的有效期间内突然发生的。</span>猝死的认定以医疗机构的诊断或公安、司法机关的鉴定以及有资质的鉴定机构出具的鉴定报告为准。
                </p>
              </p>
              <p class="text"><span class="space"></span><span class="bold">【工作期间】</span></p>
              <p class="text"><span class="space"></span>本合同所指的“工作期间 ” 发生猝死或者遭受意外事故仅限以下五种情形，<span
                  class="bold">并且不括职业病（注
              1）：</span></p>
              <p class="text"><span class="space"></span>1．在工作时间和工作场所内，发生猝死或因工作原因受到意外伤害的；
              </p>
              <p class="text"><span class="space"></span>2．在工作时间前后在工作场所内，发生猝死或从事与工作有关的预备性或者收尾性工作受到意外伤害的；
              </p>
              <p class="text"><span class="space"></span>3．在工作时间和工作场所内，发生猝死或因履职工作职责受到暴力等意外伤害的；
              </p>
              <p class="text"><span class="space"></span>4．因工外出期间，发生猝死或由于工作原因受到意外伤害的；</p>
              <p class="text"><span class="space"></span>5．在上下班途中，发生猝死或受到非本人应负主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故的意外伤害的。
              </p>
              <p class="text"><span class="space"></span>注
                1：职业病指企业、事业单位和个人经济组织等用人单位的劳动者在职业活动中接触粉尘、放射性物质和其他有毒、有害物质等因素而引起的疾病。本合同所指的职业病按照《职业病分类和目录》（国家疾控发
                [2013]48 号）划分。</p>
              <p class="text"><span class="space"></span><span class="bold">【火灾】</span></p>
              <p class="text"><span class="space"></span>指在时间或空间上失去控制的燃烧所造成的灾害。构成本合同约定的火灾意外身故和火灾意外伤残保险责任范围内的火灾必须同时具备以下三个条件：
              </p>
              <p class="text"><span class="space"></span>1．有燃烧现象，即有热有光有火焰；</p>
              <p class="text"><span class="space"></span>2．偶然、意外发生的燃烧；</p>
              <p class="text"><span class="space"></span>3．燃烧失去控制并有蔓延扩大的趋势。</p>

              <p class="text"><span class="space"></span><span class="bold">【法定节假日期间】</span></p>
              <p class="text"><span class="space"></span>法定节假日为现行有效的《全国年节及纪念日放假办法》所规定的全体公民放
                的节日及中华人民共和国国务院办公厅发布的连同上述节日的调休安排日期。全体公民放假的节日包括：新年（1 月 1
                日）、春节（农历正月初一、初二、初三）、清明节（农历清明当日）、劳动节（5 月 1 日）、端午节（农历端午当日）、中秋节（农历中秋当日）、国庆节（10
                月 1 日、2日、3 日）。</p>
              <p class="text"><span class="space"></span><span class="bold">【民用燃气意外事故】</span></p>
              <p class="text"><span class="space"></span>指因使用经燃气公司安装或同意安装的民用燃气及其所属设备引起的火灾、爆炸、燃气渗漏、燃气外泄等外来的、突发的、非本意的、非疾病的导致被保险人的身体受到伤害的客观事件，<span
                  class="bold">不包含未经燃气公司安装或同意安装的燃气及其所属设备。
            </span></p>
              <p class="text"><span class="space"></span><span class="bold">【食物中毒】</span></p>
              <p class="text"><span class="space"></span>指食用了被生物性、化学性有毒物质污染的食品或者食用了含有毒有害物质的食品后出现的急性或亚急性食源性疾患。
              </p>
              <p class="text"><span class="space"></span><span class="bold">【全残】</span></p>
              <p class="text"><span class="space"></span>指符合《劳动能力鉴定职工工伤与职业病致残等级》（GB/T
                16180-2014）中列明的一级伤残标准的伤残</p>
              <p class="text"><span class="space"></span><span class="bold">【特定场所】</span></p>
              <p class="text"><span class="space"></span>本合同所指的特定场所包括但不限于以下各类，
                由投保人和保险人在投保时协商确定，并在保险单或其他保险凭证上载明特定场所的名称和地址：</p>
              <p class="text"><span class="space"></span>1．餐饮和住宿类：宾馆、饭店、旅馆、招待所、咖啡馆、酒吧、茶座；2．净身和美容类：公共浴室、理发店、美容店；
              </p>
              <p class="text"><span class="space"></span>3．娱乐类：电影院、音乐厅；</p>
              <p class="text"><span class="space"></span>4．文化交流类：展览馆、博物馆、美术馆、图书馆；</p>
              <p class="text"><span class="space"></span>5．体育和游乐类：体育场馆、游泳场馆、动物园、公园；</p>
              <p class="text"><span class="space"></span>6．商业活动类：银行、证券公司、邮政局、通讯机构、商场、商店、书店；</p>
              <p class="text"><span class="space"></span>7．本合同约定的其他特定场所。</p>
              <p class="text"><span class="space"></span><span class="bold">特定场所一经确定，不得变更。</span></p>

              <p class="text"><span class="space"></span><span class="bold">【特定场景】</span></p>
              <p class="text"><span class="space"></span>本合同所指的特定场景包括但不限于以下各类，
                由投保人和保险人在投保时协商确定，并在保险单或其他保险凭证上载明具体特定场景：</p>
              <p class="text"><span class="space"></span>1．公益性活动及会议</p>
              <p class="text"><span class="space"></span>2．<span class="bold">志愿者（注 1）</span>参与社会服务</p>
              <p class="text"><span class="space"></span>3. 本合同约定的其他特定场景。</p>
              <p class="text"><span class="space"></span><span class="bold">注 1：志愿者须为政府机关、部门或社会组织统一招募的志愿者或持有由中国社会工作协会社区志愿者工作委员会颁发的“
            </span></p>
              <p class="text"><span class="space"></span>中国社区志愿者证 ”的志愿者。</p>
              <p class="text"><span class="space"></span><span class="bold">【见义勇为行为】</span></p>
              <p class="text"><span class="space"></span>是指不负有法定职责、法定义务或约定义务的公民为保护国家利益、社会公共利益或他人的人身、财产安全，不顾个人安危，同违法犯罪行为作斗争或者抢险、救灾、救人的行为。
              </p>
              <p class="text"><span class="space"></span>见义勇为行为，应由市/区/县及以上的公安机关、或（和）当地人民政府、或（和）保险单中载明的专业管理机构（如见义勇为基金会或协会）进行调查、取证，并在核实有关证据材料后出具的认定证明。
              </p>
              <p class="text"><span class="space"></span> 有下列行为之一的可认定为见义勇为行为：</p>
              <p class="text"><span class="space"></span>1．同正在危害国家安全、妨害公共安全或者扰乱社会公共秩序的违法犯罪行为作斗争的；
              </p>
              <p class="text"><span class="space"></span>2．同正在侵害国家、集体的财产或者他人人身、财产安全和其他权利的违法犯罪行为作斗争的；
              </p>
              <p class="text"><span class="space"></span>3．抢险、救灾、救人，或保护国家、集体的财产或者他人人身、财产安全的；
              </p>
              <p class="text"><span class="space"></span>4．其他应当确认为见义勇为的行为。</p>
              <p class="text"><span class="space"></span><span class="bold">【疫苗接种单位】</span></p>
              <p class="text"><span class="space"></span>疫苗接种单位应当具备下列条件：</p>
              <p class="text"><span class="space"></span>（一）取得医疗机构执业许可证；</p>
              <p class="text"><span class="space"></span>（二）具有经过县级人民政府卫生健康主管部门组织的预防接种专业培训并考核合格的医师、护士或者乡村医生；
              </p>
              <p class="text"><span class="space"></span>（三）具有符合疫苗储存、运输管理规范的冷藏设施、设备和冷藏保管制度。
              </p>
              <p class="text"><span class="space"></span>县级以上地方人民政府卫生健康主管部门指定符合条件的医疗机构承担责任区域内免疫规划疫苗接种工作。符合条件的医疗机构可以承担非免疫规划疫苗接种工作，
                并应当报颁发其医疗机构执业许可证的卫生健康主管部门备案。</p>
              <p class="text"><span class="space"></span><span class="bold">【合格的疫苗接种人员】</span></p>
              <p class="text"><span class="space"></span>指具备执业医师、执业助理医师、执业护士或乡村医生资格， 并经过县级卫生计生行政
              </p>
              <p class="text"><span class="space"></span>部门组织的预防接种专业培训，考核合格后可从事预防接种服务工作的人员。
              </p>
              <p class="text"><span class="space"></span><span class="bold">【疫苗】</span></p>
              <p class="text"><span class="space"></span>指为预防、控制疾病的发生、流行，
                用于人体免疫接种的预防性生物制品，包括免疫规划疫苗和非免疫规划疫苗。
              </p>
              <p class="text"><span class="space"></span><span class="bold">【预防接种异常反应】</span></p>
              <p class="text"><span class="space"></span>指合格的疫苗在实施规范接种过程中或者实施规范接种后造成受种者机体组织器官、功能损害，相关各方均无过错的药品异常反应。
              </p>
              <p class="text"><span class="space"></span><span class="bold">【殴斗】</span></p>
              <p class="text"><span class="space"></span>因被保险人挑衅或故意行为而导致的打斗、被袭击或被谋杀。</p>
              <p class="text"><span class="space"></span><span class="bold">【醉酒】</span></p>
              <p class="text"><span class="space"></span>指发生事故时被保险人每百毫升血液中的酒精含量大于或者等于 80 毫克。
              </p>

              <p class="text"><span class="space"></span><span class="bold">【毒品】</span></p>
              <p class="text"><span class="space"></span>指中华人民共和国刑法规定的鸦片、海洛因、甲基苯丙胺（冰毒）、吗啡、大麻、可卡因以及国家规定管制的其他能够使人形成瘾癖的麻醉药品和精神药品，但不包括由医生开具并遵医嘱使用的用于治疗疾病但含有毒品成分的处方药品。
              </p>
              <p class="text"><span class="space"></span><span class="bold">【酒后驾驶】</span></p>
              <p class="text"><span class="space"></span>指经检测或者鉴定，发生事故时车辆驾驶人员每百毫升血液中的酒精含量达到或者超过一定的标准，公安机关交通管理部门依据《道路交通安全法》的规定认定为饮酒后驾驶或者醉酒驾驶。
              </p>
              <p class="text"><span class="space"></span><span class="bold">【无合法有效驾驶证驾驶】</span></p>
              <p class="text"><span class="space"></span>被保险人存在下列情形之一者：</p>
              <p class="text"><span class="space"></span>（一）无驾驶证，驾驶证被依法扣留、暂扣、吊销、注销；</p>
              <p class="text"><span class="space"></span>（二）驾驶的机动车与驾驶证载明的准驾车型不符；</p>
              <p class="text"><span class="space"></span>（三）实习期内驾驶公共汽车、营运客车或者执行任务的警车、载有危险物品的机动车或牵引挂车的机动车；
              </p>
              <p class="text"><span class="space"></span>（四）使用各种专用机械车、特种车的人员无国家有关部门核发的有效操作证、许可证书或其他必备证书。
              </p>
              <p class="text"><span class="space"></span><span class="bold">【驾驶无合法有效行驶证的机动车】</span></p>
              <p class="text"><span class="space"></span>指下列情形之一：</p>
              <p class="text"><span class="space"></span>（一）未取得合法有效行驶证；</p>
              <p class="text"><span class="space"></span>（二）机动车行驶证、号牌被依法注销登记的；</p>
              <p class="text"><span class="space"></span>（三）未按规定检验或检验不合格。</p>
              <p class="text"><span class="space"></span><span class="bold">【机动车】</span></p>
              <p class="text"><span class="space"></span>指以动力装置驱动或者牵引，上道路行驶的供人员乘用或者用于运送物品以及进行工程专项作业的轮式车辆，包括超标电动车（超出《电动自行车安全技术规范》（GB
                17761-2018）中对电动自行车认定标准的电驱动或电助动的车辆）、汽车及汽车列车、摩托车、拖拉机运输机组、轮式专用机械车、挂车，
                具体认定标准根据《机动车运行安全技术条件（GB 7258—2017）》。</p>

              <p class="text"><span class="space"></span><span class="bold">【恐怖袭击】</span></p>
              <p class="text"><span class="space"></span>指以制造社会恐慌、胁迫国家机关或者国际组织为目的，采取暴力、破坏、恐吓或者其他手段，造成或者意图造成人员伤亡、重大财产损失、公共设施损坏、社会秩序混乱等严重社会危害的行为。
              </p>
              <p class="text"><span class="space"></span><span class="bold">【医疗事故】</span></p>
              <p class="text"><span class="space"></span>指医疗机构及其医务人员在医疗活动中，违反医疗卫生管理法律、行政法规、部门规章和诊疗护理规范、常规，过失造成患者人身损害的事故。
              </p>
              <p class="text"><span class="space"></span><span class="bold">【高风险运动】</span></p>
              <p class="text"><span class="space"></span>指比一般常规性的运动风险等级更高、更容易发生人身伤害的运动，
                在进行此类运动前需有充分的心理准备和行动上的准备，必须具备一般人不具备的相关知识和技能或者必须在接受专业人士提供的培训或训练之后方能掌握。被保险人进行此类运动时须具备相关防护措施或设施，以避免发生损失或减轻损失，包括但不限于潜水、滑水、滑雪、滑冰、驾驶或乘坐滑翔翼、滑翔伞、跳伞、攀岩运动、探险活动、武术比赛、摔跤比赛、柔道、空手道、跆拳道、马术、拳击、特技表演、驾驶卡丁车、赛马、赛车、各种车辆表演、蹦极。
              </p>
              <p class="text bold"><span class="space"></span>【潜水】</p>
              <p class="text"><span class="space"></span>指使用辅助呼吸器材在江、河、湖、海、水库、运河等水域进行的水下运动。
              </p>

              <p class="text bold"><span class="space"></span>【攀岩】</p>
              <p class="text"><span class="space"></span>指攀登悬崖、楼宇外墙、人造悬崖、冰崖、冰山等运动。</p>

              <p class="text bold"><span class="space"></span>【探险】</p>
              <p class="text"><span class="space"></span>指明知在某种特定的自然条件下有失去生命或使身体受到伤害的危险，而故意使自己置身于其中的行为，如：江河漂流、登山、徒步穿越沙漠或人迹罕至的原始森林等活动。
              </p>
              <p class="text bold"><span class="space"></span>【武术比赛】</p>
              <p class="text"><span class="space"></span>指两人或两人以上对抗性柔道、空手道、跆拳道、散打、拳击等各种拳术及使用器械的对抗性比赛。
              </p>
              <p class="text bold"><span class="space"></span>【特技表演】</p>
              <p class="text"><span class="space"></span>指进行马术、杂技、驯兽等表演。</p>

              <p class="text bold"><span class="space"></span>【既往症】</p>
              <p class="text"><span class="space"></span>指被保险人在本合同生效日之前患有的已知或应该知道的有关疾病或症状。包括不限于以下情况：本合同生效前，医生已有明确诊断，长期治疗未间断；医生已有明确诊断，治疗后症状未完全消失，有间断用药情况；未经医生诊断和治疗，但症状明显且持续存在足以促使一般普通谨慎人士引起注意并寻求诊断、治疗或护理的症状。
              </p>
              <p class="text bold"><span class="space"></span>【并发症】</p>
              <p class="text"><span class="space"></span>指疾病在发展过程中偶然引起的另一种疾病或症状，且新引起的疾病或症状非医务人员的过失所致。
              </p>
              <p class="text bold"><span class="space"></span>【偶合发病】</p>
              <p class="text"><span class="space"></span>指受种者在接种时正处于某种疾病的潜伏期或者前驱期，接种后巧合发病。<span
                  class="bold">偶合发病不是由疫苗的固有性质引起的。</span>
              </p>
              <p class="text bold"><span class="space"></span>【心因性反应】</p>
              <p class="text"><span class="space"></span>指在预防接种实施过程中或接种后因受种者心理因素发生的个体或者群体的反应。<span
                  class="bold">心因性反应不是由疫苗的固有性质引起的。</span>
              </p>
              <p class="text bold"><span class="space"></span>【现金价值】</p>
              <p class="text"><span class="space"></span>当交费方式为一次性支付保险费时，现金价值的计算公式为：净保险费×[1－（保险期间已经过天数/保险期间天数）]，<span
                  class="bold">经过天数不足一天的按一天计算。</span>
              </p>
              <p class="text"><span class="space"></span>当交费方式为分期支付保险费时，现金价值的计算公式为：净保险费</p>
              ×（1-当期已经过天数/当期天数）。其中，当期指本合同的本期保险费约定支付日至下期保险费约定支付日的期间；若投保人已交纳最后一期保险费，当期指本合同的本期保险费约定支付日至本合同满期之日的期间。<span
                  class="bold">经过日数不足一日按一日计算。</span>
            </p>
            <p class="text bold"><span class="space"></span>净保险费指投保人所交纳的保险费（若交费方式为分期支付时指当期保险费）扣除每张保险单平均承担的保险人各项费用（含营业费用、代理费、各项税金、保险保障基金等）后的余额，扣除部分占所交保险费的比例由投保人在投保时与保险人协商确定。
            </p>
          </p>
          <p class="text bold"><span class="space"></span>【有效身份证件】</p>
          <p class="text"><span class="space"></span>指由政府主管部门规定的证明其身份的证件，如：居民身份证、临时身份证、户口簿、按规定可使用的有效护照、军人身份证件、武装警察身份证件等证件。
          </p>
          <p class="text bold"><span class="space"></span>【离职】</p>
          <p class="text"><span class="space"></span>指用人单位与劳动者解除或终止劳动关系的行为，包括到期终止劳动合同、提前解除劳动合同、解除或终止事实劳动关系、或未经对方同意一方擅自解除或终止劳动关系等，<span
              class="bold">但不包括依法退休、病退、内部退养行为。</span>
          </p>
          <p class="text bold"><span class="space"></span>【未满期保险费】</p>
          <p class="text"><span class="space"></span>当交费方式为一次性支付保险费时，未满期保险费的计算公式为：（应收保险费-实收保险费）×（1-保险经过日数/保险期间的日数）。<span
              class="bold">经过日数不足一日按一日计算。</span>
          </p>
          当交费方式为分期支付保险费时，未满期保险费的计算公式为：（应收保险费-实收保险费）×（1-当期经过日数/当期日数）。其中，
          <p class="text"><span class="space"></span>当期指本合同的本期保险费约定支付日至下期保险费约定支付日的期间；若投保人已交纳最后一期保险费，当期指本合同的本期保险费约定支付日至本合同满期之日的期间。<span
              class="bold">经过日数不足一日按一日计算。</span>
          </p>


          <!--            <p class="bold text-center">伤残等级赔偿限额比例表</p>
                      <div class="tr">
                        <p class="th">伤残等级</p>
                        <p class="th">比例</p>
                      </div>
                      <div class="tr" v-for="(item, index) in tdList2" :key="index">
                        <p class="td">{{ item.no }}</p>
                        <p class="td">{{ item.val }}</p>
                      </div>-->

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import {Toast} from "vant";
import loading from "../components/loading";
import moblieRem from "../utils/mobile-rem";

export default {
  components: {
    loading
  },
  data() {
    return {
      tdList: [
        {name: "1", val: "10"},
        {name: "2", val: "20"},
        {name: "3", val: "30"},
        {name: "4", val: "40"},
        {name: "5", val: "50"},
        {name: "6", val: "60"},
        {name: "7", val: "70"},
        {name: "8", val: "80"},
        {name: "9", val: "85"},
        {name: "10", val: "90"},
        {name: "11", val: "95"},
        {name: "12", val: "100"}
      ],
      tdList2: [
        {no: '一级', val: "100％"},
        {no: '二级', val: "80％"},
        {no: '三级', val: "65％"},
        {no: '四级', val: "55％"},
        {no: '五级', val: "45％"},
        {no: '六级', val: "25％"},
        {no: '七级', val: "15％"},
        {no: '八级', val: "10％"},
        {no: '九级', val: "4％"},
        {no: '十级', val: "1％"},
      ],
    };
  },
  computed: {},
  mixins: [moblieRem],
  created() {
    document.title = "";
    window.scrollTo(0, 0);
  },
  mounted() {
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/addForm.less";
@import "../assets/css/commercialProject.less";

.form-content {
  padding: 0.92rem 0;
  height: auto;
}

.rule-detail .tr2 {
  padding: 0;

  .th1, .td1 {
    flex: none;
    width: 1.3rem;
  }

  .th2, .td2 {
    flex: none;
    width: 2rem;
  }

  .th1, .th2 {
    padding-top: 0.3rem;
  }
}

.text-center {
  text-align: center;
}

.mt-10 {
  margin-top: 0.2rem;
}
</style>
